import React from "react";
import { Layout, Modal, Avatar, Menu, Dropdown } from "antd";
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom"

import Routes from "./routes";
import config from "../config";
import { clearRemember } from "../utils/Session";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedKeys: "/sys/home",
        };
        global.onMenuChange = this.onMenuChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        // this.autoPlayTest();
    }
    componentDidMount() {
        let menuKey = localStorage.getItem("selectedMenuKeys");
        if (menuKey) {
            this.setState({ selectedKeys: menuKey });
        }
        global.EE.addListener("MENU_CHANGE", this.onMenuChange);
    }
    componentWillUnmount() {
        global.EE.removeListener("MENU_CHANGE", this.onMenuChange);
    }
    play = (context, decodeBuffer) => {
        // 调用resume恢复播放
        context.resume();
        let source = context.createBufferSource();
        source.buffer = decodeBuffer;
        source.connect(context.destination);
        // 从0s开始播放
        source.start(0);
    };
    requestAudio = (url) => {
        return new Promise(resolve => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            // 这里需要设置xhr response的格式为arraybuffer
            // 否则默认是二进制的文本格式
            xhr.responseType = 'arraybuffer';
            xhr.onreadystatechange = function () {
                // 请求完成，并且成功
                if (xhr.readyState === 4 && xhr.status === 200) {
                    resolve(xhr.response);
                }
            };
            xhr.send();
        });
    };
    setCustomerAudio = async () => {
        let audioPath = global.TemplateUrl + "files/audio2.mp3";
        // Safari是使用webkit前缀
        this.CustomerAudioContext = new (window.AudioContext || window.webkitAudioContext)();
        // 请求音频数据
        let audioMedia = await this.requestAudio(audioPath);
        // 进行decode和play
        this.CustomerAudioContext.decodeAudioData(audioMedia, decode => {
            this.CustomerAudioDecode = decode;
        });
    };
    setAudio = async (audioPath) => {
        // Safari是使用webkit前缀
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        // 请求音频数据
        let audioMedia = await this.requestAudio(audioPath);
        // 进行decode和play
        this.audioContext.decodeAudioData(audioMedia, decode => {
            this.audioDecode = decode;
        });
    };
    testAutoPlay() {
        // 返回一个promise以告诉调用者检测结果
        return new Promise(resolve => {
            let audio = document.createElement('audio');
            // require一个本地文件，会变成base64格式
            // audio.src = require('@/assets/empty-audio.mp3');
            audio.src = require("../assets/audio/noSound.mp3");
            document.body.appendChild(audio);
            let autoplay = true;
            // play返回的是一个promise
            audio.play().then(() => {
                // 支持自动播放
                autoplay = true;
            }).catch(err => {
                // 不支持自动播放
                autoplay = false;
            }).finally(() => {
                audio.remove();
                resolve(autoplay);
            });
        });
    }
    autoPlayTest = async () => {
        this.autoPlay = await this.testAutoPlay();
        console.log("autoPlay", this.autoPlay);
        if (!this.autoPlay) {
            Modal.info({
                title: '提示',
                content: '浏览器当前无法播放声音，请点击确定按钮，以便及时接收到用户信息。',
                okText: '确定'
            });

        }
    };
    onMenuChange = (key) => {
        localStorage.setItem("selectedMenuKeys", key);
        this.setState({ selectedKeys: key })
        this.props.history.push({ pathname: key });
    };
    clearLogout = () => {
        clearRemember();
        this.props.history.push({ pathname: '/login' });
        // let url = global.delParam("token");
        // window.location.href = url + '/#/login';
    };
    onLogout = () => {
        Modal.confirm({
            title: "退出账号",
            // icon: <ExclamationCircleOutlined />,
            content: "确定要退出当前账号吗？",
            okText: '退出',
            cancelText: '取消',
            onOk: () => this.clearLogout()
        });
    };
    logout = () => {
        // this.props.appStore.toggleLogin(false);
        global.sendMsg({ code: 'QUIT', account: global.loginUser._id, token: window.token })
        this.props.history.push({ pathname: '/login' })
        global.loginUser = null;

        // let url = this.delParam("token");
        // window.location.href = url + '/admin/#/login';
    };
    handleCancel = () => {
        this.setState({ newCallVisible: false });
    }
    goToPage = (pathName) => {
        this.props.history.push({ pathname: pathName });
    };
    render() {
        let menus = config.menus || [];
        const { selectedKeys } = this.state;
        const menu = (
            <Menu className="menu" style={{ paddingBottom: 10 }}>
                <Menu.ItemGroup title="用户中心" className="menu-group">
                    <Menu.Item onClick={() => this.goToPage("/sys/userCenter")}>个人中心</Menu.Item>
                </Menu.ItemGroup>
            </Menu>
        );
        const userCenter = (
            <Dropdown overlay={menu}>
                <Avatar style={Styles.userSetting} icon={<UserOutlined style={{ fontSize: 12, color: '#444' }} />} />
            </Dropdown>
        );

        return (
            <div id="page">
                <Layout>
                    <div style={{ height: "20vh", backgroundColor: "#4377F3" }} />
                    <div style={{ height: "80vh" }} />
                    <div style={{
                        width: "90vw", height: "90vh",
                        top: "5vh", left: "5vw",
                        position: "absolute",
                        backgroundColor: "rgba(255,255,255,.2)",
                        boxShadow: "0px 0px 5px rgba(0,0,0,.3)",
                    }}>
                        <div style={{ height: "15vh" }}>
                            <div style={{ height: "5vh", color: "#FFF", borderBottom: ".3px solid rgba(255,255,255,.2)", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", padding: "0px 15px" }}>
                                <div style={{ flex: 1, color: "#FFF" }}>
                                    <div>欢迎您！{global.loginUser ? global.loginUser.name : ""}</div>
                                </div>
                                {userCenter}
                                <span style={{ cursor: "pointer" }} onClick={() => this.onLogout()}>
                                    <LogoutOutlined />
                                    <span style={{ color: '#fff', paddingRight: 15, paddingLeft: 8, cursor: "pointer" }}>退出</span>
                                </span>
                            </div>
                            <div style={{ height: "10vh", display: "flex", flexDirection: "row", margin: "0px 20px", alignItems: "center", justifyContent: "center" }}>
                                <div style={{ flex: 1, color: "#FFF" }}>
                                    <div style={{ fontSize: 23, fontWeight: "bold" }}>{config.title}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {
                                        menus.map((menu) => {
                                            if (menu.role === "管理人员" && !global.isAdmin(global.loginUser)) {
                                                return null;
                                            }
                                            return (
                                                <Link key={menu.key} to={menu.key} onClick={() => this.onMenuChange(menu.key)}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        margin: 10,
                                                    }}>
                                                        <div style={{
                                                            width: 40, height: 40,
                                                            borderRadius: 20,
                                                            backgroundColor: (selectedKeys === menu.key) ? "rgba(255,255,255,.2)" : "rgba(0,0,0,.2)",
                                                            color: "#FFF",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: 15,
                                                        }}>
                                                            {menu.icon}
                                                        </div>
                                                        <div style={{ color: "#FFF", fontSize: 13 }}>
                                                            {menu.name}
                                                        </div>
                                                    </div>
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                        <Layout.Content style={{ height: "75vh", overflowY: "auto" }}>
                            <Routes />
                        </Layout.Content>
                    </div>
                    <div style={{ position: 'absolute', top: 0, right: 5, color: "#FFF" }}>版本：{config.version}</div>
                </Layout>
            </div>
        );
    }
}

const Styles = {
    item: {
        margin: "0 10px",
    },
    menuItem: {
        fontWeight: '800',
        fontSize: 14,
        paddingLeft: 10,
        paddingRight: 10,
        color: "#333"
    },
    userSetting: {
        backgroundColor: '#c2d4ff',
        width: 25, height: 25,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 15
    }
}

export default Index
